import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";

import clsx from 'clsx';

import CloseIcon from '@mui/icons-material/Close';

import {
    appSetAlert
} from "../../redux/app/appActions";

import { styled, Collapse, Alert, AlertTitle, IconButton } from '@mui/material';

const PREFIX = 'transitionAlert';

const classes = {
    root: `${PREFIX}-root`,
    hide: `${PREFIX}-hide`,
    alert: `${PREFIX}-alert`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        width: '100%'
        // '& > * + *': {
        //     marginTop: theme.spacing(2)
        // },
        // marginBottom: theme.spacing(2)
    },

    [`&.${classes.hide}`]: {
        display: 'none'
    },

    [`& .${classes.alert}`]: {
        margin: theme.spacing(2)
    }
}));

export default function TransitionAlert() {

    const dispatch = useDispatch();

    // App State
    const alert = useSelector(state => state.app.alert);

    const [open, setOpen] = React.useState(false);
    const [title, setTitle] = React.useState(null);
    const [message, setMessage] = React.useState(null);
    const [severity, setSeverity] = React.useState("error");
    const [timeoutID, setTimeoutID] = React.useState(null);

    // Note: Transition Alert is a single message NOT
    // a queue
    useEffect(() => {
        if (alert.message) {
            // TODO: Push messages into array stack
            setTitle(alert.title);
            setMessage(alert.message);
            setSeverity(alert.severity);
            setOpen(true);

            // Automatically close
            if (alert.timeout) {
                const newTimeoutID = setTimeout(function () {
                    setOpen(false);

                    // Destroy the existing message
                    dispatch(appSetAlert(null, null, null, null));
                }, alert.timeout);
                setTimeoutID(newTimeoutID)
            }
        } else {
            setOpen(false);
        }
    }, [alert]);

    useEffect(() => {
        if (alert.timeout === null) {
            if (timeoutID) {
                setTimeoutID(null);
                clearTimeout(timeoutID);
            }
        }
    }, [alert.timeout]);

    //<Paper className={clsx(classes.paper, {[classes.pointer]: route })} onClick={route ? handleDrillThrough : null}>
    return (
        <Root className={clsx(classes.root, {[classes.hide]: !open })}>
            <Collapse in={open}>
                <Alert
                    severity={severity}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setOpen(false);
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                    className={classes.alert}
                >
                    <AlertTitle>{title}</AlertTitle>
                    {message}
                </Alert>
            </Collapse>
        </Root>
    );
}
